import { ActionCreatorWithoutPayload, createAction } from '@reduxjs/toolkit'

export const closeCheckout: ActionCreatorWithoutPayload = createAction('closeCheckout')
